import { type DefaultSwitchProps } from "../../components/notifyStep/NotifyStepContent/switches/DefaultSwitch";
import {
  SwitchWithProgress,
  type SwitchWithProgressProps,
} from "../../components/notifyStep/NotifyStepContent/switches/SwitchWithProgress";
import { initialNotifyConfigDefault, initialNotifyConfigWithProgress } from "./config";
import { NotifyStepConfig } from "./types";
import { NotifyStepSwitch } from "../../components/notifyStep/NotifyStepSwitch";

export const getNotifyConfig = (type: NotifyStepConfig) => {
  switch (type) {
    case NotifyStepConfig.Default:
      return {
        config: initialNotifyConfigDefault,
        NotifyConfigSwitch: (switchProps: DefaultSwitchProps) => (
          <NotifyStepSwitch
            switchProps={switchProps}
            onNotifyConfigChange={switchProps.onNotifyConfigChange}
            config={switchProps.config}
          />
        ),
      };
    case NotifyStepConfig.WithProgress:
      return {
        config: initialNotifyConfigWithProgress,
        NotifyConfigSwitch: (switchProps: SwitchWithProgressProps) => <SwitchWithProgress {...switchProps} />,
      };
  }
};
